import type mdast from 'mdast';
import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import { unified } from 'unified';
import { removePosition } from 'unist-util-remove-position';
import { newlinesToBreaks } from './remark/newlinesToBreaks';

const processor = unified()
  .data('settings', { position: false })
  .use(remarkParse)
  .use(remarkGfm)
  .use(newlinesToBreaks);

export function markdownAstFromString(markdown: string): mdast.Root {
  const parsed = processor.parse(markdown);
  const transformed = processor.runSync(parsed);
  removePosition(transformed, true);
  return transformed;
}
